const getAccessToken = () => {
  const loginRes = localStorage.getItem('loginRes');
  const parsedLoginRes = JSON.parse(loginRes);

  return parsedLoginRes.access_token;
};

export default getAccessToken;
